<template>
  <div>
    <v-card-title class="text--center"> </v-card-title>
    <v-card>
      <v-card-title>
        Documents affectés
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :items-per-page="10"
        :headers="headers"
        :items="cardStats"
        :search="search"
        no-results-text="The stuff you're looking for doesn't exist"
        no-data-text="Vous n'avez encore aucune commande"
        class="elevation-1"
      >
        <!-- templating for dialog -->

        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-card class="mt-3" width="500px" flat>
                      <v-form
                        class="input--fields__wrapper"
                        ref="form_card"
                        lazy-validation
                        v-on:submit.prevent="save"
                      >
                        <div class="input--fields__container">
                          <v-text-field
                            readonly
                            outlined
                            v-model="editedItem.entity"
                            label="Entité"
                            prepend-icon="mdi-account"
                            required
                          ></v-text-field>
                          <v-text-field
                            readonly
                            outlined
                            v-model="editedItem.legalRepresentative"
                            label="Représentant légal"
                            prepend-icon="mdi-scale-balance"
                            required
                          ></v-text-field>
                        </div>
                        <div class="input--fields__container">
                          <v-text-field
                            readonly
                            outlined
                            v-model="editedItem.email"
                            label="E-mail"
                            prepend-icon="mdi-email"
                            required
                          ></v-text-field>
                          <v-text-field
                            readonly
                            outlined
                            v-model="editedItem.requestType"
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                            label="Nature de demande"
                            prepend-icon="mdi-pen"
                            required
                          ></v-text-field>
                        </div>
                        <div class="input--fields__container">
                          <v-text-field
                            readonly
                            outlined
                            v-model="editedItem.landPhoneNumber"
                            maxLength="10"
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                            label="Téléphone fixe"
                            prepend-icon="mdi-phone"
                            required
                          ></v-text-field>
                          <v-text-field
                            readonly
                            outlined
                            v-model="editedItem.phoneNumber"
                            maxLength="10"
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                            label="Téléphone mobile"
                            prepend-icon="mdi-cellphone-android"
                            required
                          ></v-text-field>
                        </div>
                        <v-textarea
                          readonly
                          outlined
                          v-model="editedItem.requestMessage"
                          label="Message"
                          prepend-icon="mdi-comment-text-outline"
                        ></v-textarea>

                        <v-container fluid>
                          <!-- <v-chip class="mx-4 mb-2" v-for="tag in editedItem.requestFiles" :key="tag"


            v-model="editedItem.requestFiles"
            color="success" 
            text-color="white">
             &nbsp;
             
              <v-icon left>mdi-paperclip</v-icon>
              {{tag.substring(1,11)}}
              </v-chip> -->

                          <v-chip
                            @click="url(tag.location)"
                            v-for="(tag, index) in editedItem.requestFiles"
                            :key="index + tag"
                          >
                            <v-avatar left>
                              <v-icon>mdi-file</v-icon>
                            </v-avatar>
                            {{ tag.name }}
                          </v-chip>
                        </v-container>

                        <v-divider class="mt-3 "></v-divider>

                        <!-- Additional Fields go here -->
                        <div class="mt-6">
                          <div class="input--fields__container">
                            <v-text-field
                              outlined
                              v-model="editedItem.externalId"
                              maxLength="10"
                              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                              label="ID Externe"
                              prepend-icon="mdi-greater-than"
                              required
                            ></v-text-field>

                            <v-text-field
                              outlined
                              v-model="editedItem.marketNumber"
                              maxLength="10"
                              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                              label="Numéro du marché"
                              prepend-icon="mdi-home-variant"
                              required
                            ></v-text-field>
                          </div>

                          <v-text-field
                            outlined
                            v-model="editedItem.callofferNumber"
                            maxLength="10"
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                            label="Numéro d'appel d'offre / Consultation"
                            prepend-icon="mdi-offer"
                            required
                          ></v-text-field>
                        </div>

                        <!--   -->
                      </v-form>
                    </v-card>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <template>
            <v-row justify="center">
              <v-dialog v-model="dialogS" max-width="290">
                <v-card class="mt-3" width="500px" flat>
                  <v-container
                    id="scroll-target"
                    style="max-height: 400px"
                    class="overflow-y-auto"
                  >
                    <v-row
                      v-scroll:#scroll-target="onScroll"
                      align="center"
                      justify="center"
                    >
                    </v-row>
                    <v-alert
                      v-if="editedItem.affectedTo.length === 0"
                      border="top"
                      colored-border
                      type="info"
                      elevation="2"
                    >
                      Personne n'est affecté
                    </v-alert>
                    <v-chip
                      class="mt-6 mx-4"
                      v-for="(person, index) in editedItem.affectedTo"
                      :key="index + person"
                    >
                      <v-avatar left>
                        <v-icon>mdi-account</v-icon>
                      </v-avatar>

                      {{ person }}
                    </v-chip>
                  </v-container>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
        </template>
        <!-- Second DIALOG -->

        <!-- ENDS HERE -->
        <template v-slot:item.Bought="{ item }">
          <v-icon medium class="ml-2" v-on:click="editItem(item)">
            mdi-file-chart
          </v-icon>
        </template>
        <template v-slot:item.affectedTo="{ item }">
          <v-icon medium class="ml-5" @click="activate(item)">
            mdi-file-send
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: `Home`,
  components: {},
  mounted() {
    this.$store
      .dispatch('affected/NewDocument_Affected', this.User)
      .then((resp) => {
        this.cardStats = resp.data.requests;
        this.cardStats.forEach((document) => {
          document.requestDate = moment(document.requestDate).format(
            'YYYY/MM/DD'
          );
        });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          this.$store.dispatch('loginstore/logout').then((resp) => {
            this.$router.push('/');
          });
        }
      });
    this.checkRendering();
  },
  methods: {
    checkRendering() {
      this.$store.state.sdrawer.toRender = true;
    },
    editItem(item) {
      this.editedIndex = this.cardStats.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    activate(item) {
      this.editedIndex = this.cardStats.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogS = true;
    },
    isClicked() {
      this.$store
        .dispatch('affected/IsOpened_Affected', {
          userName: this.User.name,
          requestId: this.editedItem.requestId,
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$store.dispatch('loginstore/logout').then((resp) => {
              this.$router.push('/');
            });
          }
        });
    },
    save() {
      this.$store
        .dispatch('affected/AffectedEditing', {
          userName: this.User.name,
          requestId: this.editedItem.requestId,
          externalId: this.editedItem.externalId,
          marketNumber: this.editedItem.marketNumber,
          callofferNumber: this.editedItem.callofferNumber,
        })
        .then((resp) => {
          if (this.editedIndex > -1) {
            Object.assign(this.cardStats[this.editedIndex], this.editedItem);
          } else {
            this.cardStats.push(this.editedItem);
          }
          this.close();
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$store.dispatch('loginstore/logout').then((resp) => {
              this.$router.push('/');
            });
          }
        });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    url(name) {
      window.open(`${name}`);
    },
  },
  computed: {
    _headers() {
      return this.User.role === 'pawn'
        ? this.headers.filter((x) => x.show)
        : this.headers;
    },
    User() {
      return this.$store.state.loginstore.user;
    },
  },
  data: () => ({
    dialog: false,
    dialogS: false,
    editedIndex: -1,
    editedItem: {
      requestId: '',
      requestDate: '',
      requestFiles: '',
      requestMessage: '',
      requestType: '',
      entity: '',
      email: '',
      legalRepresentative: '',
      landPhoneNumber: '',
      phoneNumber: '',
      Bought: '',
      affectedTo: '',
      // Additional variables //
      externalId: '',
      marketNumber: '',
      callofferNumber: '',
    },
    defaultItem: {
      requestId: '',
      requestDate: '',
      requestFiles: '',
      requestMessage: '',
      requestType: '',
      entity: '',
      email: '',
      legalRepresentative: '',
      landPhoneNumber: '',
      phoneNumber: '',
      Bought: '',
      affectedTo: '',
      // Additional variables //
      ExternalId: '',
      MarketNumber: '',
      OfferNumber: '',
    },
    headers: [
      {
        text: 'Numéro du document',
        sortable: false,
        value: 'requestId',
        show: true,
      },
      { text: 'Numéro de marché', value: 'marketNumber', show: true },
      { text: 'Date du document', value: 'requestDate', show: true },
      { text: 'Expéditeur', value: 'entity', show: true },
      { text: 'Nature du document', value: 'requestType', show: true },
      { text: 'Détails', value: 'Bought', show: true },
      { text: 'Affectation', value: 'affectedTo', show: false },
    ],
    cardStats: [],
    search: '',
  }),
};
</script>
<style scoped>
.page__event--container {
  max-width: 1148px;
  width: 100%;
  margin: 0 auto;
}

.input--fields__container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}

.v-card {
  border-radius: 8px;
}

@media only screen and (max-width: 375px) {
  .page__event--container {
    margin: 0 auto;
  }

  .input--fields__submit_ren {
    margin-left: 5px !important;
    padding: 0 !important;
  }
  .input--fields__submit_ja {
    margin-left: 5px !important;
  }
  .card_x {
    margin-top: 12px;
    width: 600px;
  }
  .col_card {
    margin-right: 40px;
  }
}

.v-text-field__slot input {
  text-align: left;
}
</style>
